// removed by extract-text-webpack-plugin
module.exports = {"ChatWidgetDesign":"ChatWidgetDesign---3VxWT"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/ChatWidget/components/Design/style.styl
// module id = v/lX
// module chunks = 89